const lineHeight = {
  xsmall: '14px',
  small: '18px',
  medium: '20px',
  large: '24px',
  xlarge: '30px',
  xxlarge: '36px',
};
export default lineHeight;
